// extracted by mini-css-extract-plugin
export default {"genappContainer":"V4FSD","lastUpdatedContainer":"vhUhO"};